import { useSkin } from "@hooks/useSkin"
import { Link, useNavigate } from "react-router-dom"
import InputPasswordToggle from "@components/input-password-toggle"
import {
  Row,
  Col,
  Form,
  Label,
  Input,
  Button,
  Spinner,
  FormFeedback,
  Card
} from "reactstrap"
import "@styles/react/pages/page-authentication.scss"
import { Apple, ApplePlayText, AuthPlayAppleButton, ButtonText, DownloadText, LoginBold, LoginHead } from "../StyledComponents"

import { useDispatch } from 'react-redux'
import { useState, useContext } from "react"

import { AbilityContext } from '@src/utility/context/Can'
import toast from 'react-hot-toast'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, Controller } from 'react-hook-form'
import apple from '../assets/images/loginSocial/apple-logo.svg'
import google from '../assets/images/loginSocial/google.svg'
import facebook from '../assets/images/loginSocial/facebook.svg'
import forgotPass from '../assets/images/auth/forgot-new.svg';
// import forgotPass from '../assets/images/auth/forgot-password.png';
import logo from '../assets/images/logo/logo.svg';
import maelano from '../assets/images/logo/maelano-color.svg';
import playstore from '../assets/images/logo/playstore.svg'
import appleWhite from '../assets/images/logo/apple.svg'
import ManageServices from "../utility/api/services/ManageServices"

const ForgotPassword = () => {
  const { skin } = useSkin()

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ability = useContext(AbilityContext)


  // Validation Schema for the form
  const LoginSchema = yup.object().shape({
    email: yup.string()
      .required("Please enter your email")
      .test('is-valid', 'Invalid email', value => {
        return yup.string().email().isValidSync(value);
      }),
    code: yup.string().required('Please enter your code'),
  })

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    getValues
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(LoginSchema),
    defaultValues: { email: '', password: '' }
  })

  const [loadingLogin, setLoadingLogin] = useState(false)
  const [codeSent, setCodeSent] = useState(false);
  const [codeEnabled, setCodeEnabled] = useState(false);
  const emailValue = watch('email');
  const codeValue = watch('code');

  const handleSendCode = () => {
    const email = getValues('email');
  if (email) {
    const obj = {
      email:email
    }
    ManageServices.postResetPassReqCode(obj)
    .then((response) => {
      const result = response.data
      console.log('RESULT', result)
      if(result.statusCode == 200){
        setCodeSent(true);
        setCodeEnabled(true);
        return toast.success(result.message)

      }else if(result.statusCode == 404){
        return toast.error(result.message)
      }
      
  })
  } else {
      toast.error("Please enter your email");
    }
  };

  const onLoginSubmit = (data) => {
    setLoadingLogin(true);
    console.log('Login Data:', data);
  
    if (data.email === "") {
      toast.error('Please enter your email');
      setLoadingLogin(false);
    } else if (data.code === "") {
      toast.error('Please enter your code');
      setLoadingLogin(false);
    } else {
      const obj = {
        email: data.email,
        code: data.code,
        type: "passwordreset"
      };
  
      ManageServices.postResetPassVerifyCode(obj)
        .then((response) => {
          const result = response.data;
          console.log('RESULT', result);
  
          if (result.statusCode === 200) {
            toast.success(result.message);
            navigate('/reset-password');
          } else if (result.statusCode === 404) {
            toast.error(result.message);
          }
  
          setLoadingLogin(false);
        })
        .catch((error) => {
          console.error('Error:', error);
          toast.error('Please try again');
          setLoadingLogin(false);
        });
    }
  };
  


  return (
  <>
    
<div className='auth-wrapper auth-cover'>
    <Row className='auth-inner m-0'>
   
    
      <Col className='d-flex auth-bg px-3 px-lg-5' lg='6' sm='12'>
        <Col className='px-xl-2 mx-auto d-flex flex-column justify-content-center' sm='12' md='6' lg='12'>
          <div className="d-flex flex-column justify-content-center align-items-center p-3">
            <Link className='maelano d-flex flex-column flex-md-row text-center align-items-center gap-2 gap-md-0' to='/' onClick={e => e.preventDefault()}>
              <img src={logo} style={{ color: '#3E5859', width: '50px', height: '38px', marginRight: '10px' }} />
              <img className='img-fluid' src={maelano} alt='MAELANO' />
            </Link>
          </div>
         <LoginHead className="mb-md-2">FORGOT PASSWORD</LoginHead>
         <LoginBold className="mb-md-4">Let’s reset to retrieve password</LoginBold>
         <Form className='auth-login-form mt-2' onSubmit={handleSubmit(onLoginSubmit)}>
              <Row>
                <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                  <div className="mb-1">
                    <Label className="form-label" for="email">Email</Label>
                    <Controller
                      id='email'
                      name='email'
                      control={control}
                      render={({ field }) => (
                        <Input
                          autoFocus
                          placeholder='Enter your email'
                          invalid={errors.email && true}
                          {...field}
                        />
                      )}
                    />
                    {errors.email && <FormFeedback>{errors.email.message}</FormFeedback>}
                  </div>
                </Col>
                <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                  <Button size="md" type='button' color='light-primary' onClick={handleSendCode} style={{ color: 'white', borderRadius: '8px', backgroundColor: "#41B8E4", marginBlock: '10px' }}>Send Code</Button>
                </Col>
                <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                  <div className="mb-1">
                    <Label className="form-label" for="code">Code</Label>
                    <Controller
                      id='code'
                      name='code'
                      control={control}
                      render={({ field }) => (
                        <Input
                        autoFocus
                        type="text"
                        placeholder='Enter Code'
                        disabled={!codeEnabled}
                        invalid={errors.code && true}
                        {...field}
                      />
                        
                      )}
                    />
                    {errors.code && <FormFeedback>{errors.code.message}</FormFeedback>}
                  </div>
                </Col>
                <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                  <div style={{ display: 'flex', width: '100%', justifyContent: 'center', padding: '1rem' }}>
                    <Button type="submit" block
                      color='light-primary'
                      disabled={!codeEnabled || !codeValue}
                      style={{
                        color: 'white',
                        borderRadius: '20px',
                        backgroundColor: '#F2C736',
                        height: '50px',
                        maxWidth: '318px',
                      }}
                    >
                      {
                        loadingLogin ?
                          <Spinner size="sm" /> :
                          <ButtonText>RESET PASSWORD</ButtonText>
                      }
                    </Button>
                  </div>
                </Col>
              </Row>

            </Form>

            <div className='d-flex flex-row gap-2 justify-content-center mt-0'>
            <AuthPlayAppleButton>
              <Apple src={appleWhite} />
              <div className='d-flex flex-column'>
                <DownloadText>Download on the</DownloadText>
                <ApplePlayText>Apple Store</ApplePlayText>
              </div>
            </AuthPlayAppleButton>
            <AuthPlayAppleButton>
              <Apple src={playstore} />
              <div className='d-flex flex-column'>
                <DownloadText>Download on the</DownloadText>
                <ApplePlayText>Google Play</ApplePlayText>
              </div>
            </AuthPlayAppleButton>
          </div>
        </Col>
      </Col>

      <Col className='d-none d-lg-flex' lg='6' sm='12'>
        <div className='w-100 d-lg-flex align-items-start justify-content-center'>
          <img className='img-fluid h-100 object-fit-cover' src={forgotPass} alt='Forgot Password' />
        </div>
      </Col>
    </Row>
  </div>

  </>
  )
}

export default ForgotPassword
